function ninjaGameHalloween(canvasJQ,game_conf,conf){
    ninjaGame.call(this,canvasJQ,game_conf,conf);
    
    
    var i,imgObj={};
    this.game_obj= new cutGame(canvasJQ,{
        imagesPreloader:$.extend(imgObj,{
            pumpkin1:_IMG_SERV+"/gfx/place/gameninja/halloween/pumpin/1/ready.png",
            pumpkin2:_IMG_SERV+"/gfx/place/gameninja/halloween/pumpin/2/ready.png",
            pumpkin3:_IMG_SERV+"/gfx/place/gameninja/halloween/pumpin/3/ready.png",
            pumpkin_die:_IMG_SERV+"/gfx/place/gameninja/halloween/pumpin/die/ready.png",
            cat_down:_IMG_SERV+"/gfx/place/gameninja/halloween/cat/down/anim.png",
            cat_fly:_IMG_SERV+"/gfx/place/gameninja/halloween/cat/fly/anim.png",
            cat_claws:_IMG_SERV+"/gfx/place/gameninja/halloween/cat/claws.png",
        }),
        spinePreloader:{
            help:_IMG_SERV+"/gfx/place/girls/gamebook/spine_help/skeleton.json",
            witch:_IMG_SERV+"/gfx/place/gameninja/halloween/witch/spine/skeleton.json",
            witch_die1:_IMG_SERV+"/gfx/place/gameninja/halloween/witch/fall1/skeleton.json",
            witch_good:_IMG_SERV+"/gfx/place/gameninja/halloween/witch_good/skeleton.json",
            pumpkin_toxic:_IMG_SERV+"/gfx/place/gameninja/halloween/pumpin/toxic/skeleton.json",
            witch_big:_IMG_SERV+"/gfx/place/gameninja/halloween/witch/fall_big_jpg/skeleton.json",
            cat_down_die:_IMG_SERV+"/gfx/place/gameninja/halloween/cat/down_die/skeleton.json",
            cat_fly_die:_IMG_SERV+"/gfx/place/gameninja/halloween/cat/fly_die/skeleton.json",
            cat_spirit:_IMG_SERV+"/gfx/place/gameninja/halloween/cat/spirit/skeleton.json",
            bat:_IMG_SERV+"/gfx/place/gameninja/halloween/bat/all/skeleton.json"
        },
        onLoad:function(){
            $.triggerPlacePreloader(1);
        }
    });
    
    var gameObj=this.game_obj;
    
    function witchGood(bonus2){
        PIXI.Container.call(this);
        this.have_it=intval(bonus2);
        this.obj;
        this.step_max=0;
        this.conf={howlong:10000,opacity_howlong:1000};
        this.step=0;
        this.opacity_step_max=0;
    }
    witchGood.prototype = Object.create(PIXI.Container.prototype);
    witchGood.prototype= $.extend( witchGood.prototype,{
        addView:function(){
            this.obj=new myPixiElement.spine({img:"witch_good",
                spine_conf:{
                    anim_name:"standby",
                    anim_loop:true,
                    spineResource:gameObj.takeSpineResources()
                }
            });
            this.x=1280;
            this.y=780;
            this.addChild(this.obj);
            gameObj.gameObj.viewContainer.addChild(this);
            gameObj.gameObj.viewArr.push(this);
            
        },
        update:function(delta,speed){
            var res=1;
            if(this.step_max>0){
                this.step+=delta;
                if(this.step>this.step_max){
                    this.step_max=0;
                    this.step=0;
                    this.obj.state.setAnimation(0, 'stop', false);
                    gameObj.gameObj.speed=70;
                }
            }
            else if(this.opacity_step_max>0){
                this.step+=delta;
                if(this.step>=this.opacity_step_max){
                    res=0;
                     gameObj.gameObj.speed=100;
                }
                else{
                    this.alpha=1-(this.step/this.opacity_step_max);
                }
            }
            
            return res;
        },
        remove:function(){
            
        },
        isActive:function(){
            if(this.step_max>0 && this.step<this.step_max){
                return 1;
            }
            return 0;
        },
        canUse:function(){
            if(this.have_it){
                return 1;
            }
            return 0;
        },
        use:function(){
            if(!this.have_it){
                return 0;
            }
            this.have_it=0;
            var step_time=1000/60;
            var opacity_max=Math.round(this.conf.opacity_howlong/step_time);
            var step_max=Math.round(this.conf.howlong/step_time)-opacity_max;
            
            this.step_max=step_max;
            this.opacity_step_max=opacity_max;
            gameObj.gameObj.speed=30;
            
            this.obj.state.setAnimation(0, 'start', false);
            this.obj.state.addAnimation(0, 'action', true, 0);
            
            
            return 1;
        }
        
    });
    
    this.witchObj=new witchGood(game_conf.bonus2);
    
    
};


ninjaGameHalloween.prototype = Object.create(ninjaGame.prototype);
ninjaGameHalloween.prototype=$.extend(ninjaGameHalloween.prototype,{
    test:function(){
       
       
        
    },
    startView:function(){
        var thc=this;
        if(this.witchObj.canUse()){
            this.witchObj.addView();
            this.game_obj.gameObj.gameLoopStart=function(delta){
                thc.witchObj.update(delta);
            };
        }
        
    },
    nextStage:function(conf){
        
        var egg=mt_rand(conf.egg_min,conf.egg_max);
        var chick=mt_rand(conf.chick_min,conf.chick_max);
        var bat=mt_rand(0,chick);
        
        var gameObj=this.game_obj;
        var gameConf=this.game_conf;
        var i;
        
        function addEgg(){
            var val=mt_rand(1,3);
            var scale=mt_rand(70,100);
            gameObj.addThrow("egg",$.extend(copyObj(gameConf.hard_row),{
                sprite_conf:{
                    clips:3,
                    frame_duration:200,
                    floop:false
                },
                anim_type:"sprite",
                img:"pumpkin"+val,
                map_name:"halloween_pumpkin"+val,
                rotation_step_arr:[3,12],
                scale_arr:[scale,scale],
                onCut:function(obj){
                    _mySound.playSound("hall_pumpkin_cut");
                    var angle_die=mt_rand(0,359);
                    this.addFrontObj(myPixiObj.drawCustom,[{
                        sprite_conf:{
                            clips:8,
                            columns:3
                        },
                        anim_type:"sprite",
                        img:"pumpkin_die",
                        rotation_arr:[angle_die,angle_die],
                        step_max:22,
                        scale_arr:[obj.cut_data.scale,obj.cut_data.scale],
                        pos_start:obj.cut_data.pos,pos_end:obj.cut_data.pos
                    }]);
                    
                },
                onEnd:function(obj){
                    _mySound.playSound("soccer_explosion");
                   
                    
                    
                     var pos=obj.cut_data.pos;
                     pos[1]=780;
                     var scale=100;//obj.cut_data.scale
                    var qobj=this.addViewObj(myPixiObj.drawCustom,[{
                        spine_conf:{
                            spineResource:gameObj.takeSpineResources(),
                            onAnimComplete:function(){
                                qobj.step_max=1;
                            }
                        },
                        anim_type:"spine",
                        img:"pumpkin_toxic",
                        scale_arr:[scale,scale],
                        step_max:0,
                        dir:obj.cut_data.dir,
                        v:3,
                        pos_start:pos,pos_end:pos
                    }]);
                    
                }
            }));
        }
        
        for(i=0;i<egg;i++){
            addEgg();
        }
        
        
        
        
        function addCat(){
            _mySound.playSound("hall_cat_start");
            gameObj.addThrow("chick",$.extend(copyObj(gameConf.hard_row),{
                h_max:780,
                w_margin:50,
                sprite_conf:{
                    clips:10,
                    frame_duration:50,
                    floop:true
                },
                anim_type:"sprite",
                img:"cat_fly",
                map_name:"halloween_cat_fly",
                step_part:mt_rand(50,60)/100,
                scale_arr:[30,80],
                onCut:function(obj){
                    _mySound.playSound("hall_cat_cut");
                    
                    
                    var angle_die=mt_rand(0,359);
                    
                    this.addViewObj(myPixiObj.drawCustom,[{
                        spine_conf:{
                            anim_loop:true,
                            spineResource:gameObj.takeSpineResources()
                        },
                        anim_type:"spine",
                        img:"cat_spirit",
                        scale_arr:[obj.cut_data.scale,obj.cut_data.scale],
                        step_max:0,
                        dir:obj.cut_data.dir,
                        v:3,
                        pos_start:obj.cut_data.pos,pos_end:[obj.cut_data.pos[0],-200]
                    }]);
                    
                    this.addViewObj(myPixiObj.drawCustom,[{
                        spine_conf:{
                            anim_loop:true,
                            anim_name:"Kot1",
                            spineResource:gameObj.takeSpineResources()
                        },
                        anim_type:"spine",
                        img:"cat_fly_die",
                        rotation_arr:[angle_die,angle_die],
                        scale_arr:[obj.cut_data.scale*0.4,obj.cut_data.scale*0.4],
                        step_max:0,
                        dir:obj.cut_data.dir,
                        v:5,
                        a:0.05,
                        pos_start:obj.cut_data.pos,pos_end:[obj.cut_data.pos[0],1000]
                    }]);
                
                    
                },
                onEnd:function(obj){
                    var pos_start=obj.cut_data.pos;
                    var pos_end=[pos_start[0],1000];
                    var scale=obj.cut_data.scale;
                    var speed=2;
                    
                    var cat=gameObj.addCollisionCustom("chick",{
                        img:"cat_down",
                        anim_type:"sprite",
                        pos_start:pos_start,
                        pos_end:pos_end,
                        step_max:0,
                        scale_arr:[scale,scale],
                        v:speed,
                        map_name:"halloween_cat_down",
                        sprite_conf:{
                            clips:14,
                            frame_duration:50,
                            floop:true

                        },
                    });
                    var cat_pos=[pos_start[0],pos_start[1]-cat.height/2];
                    var claws=gameObj.addViewObj(myPixiObj.drawCustom,[{
                        img:"cat_claws",
                        anim_type:"imgFrame",
                        pos_start:cat_pos,
                        pos_end:cat_pos,
//                        opacity_arr:[100,0],
                        step_max:1000,
                        scale_arr:[scale,scale],
                        imgFrame_conf:{
                            s_arr:["max",66],
                            v_arr:[0,speed*100/scale],
                            anchor_arr:[0.5,0]
                        },
                    }]);
                    claws.myObj.playSound("hall_cat_claws");
                
                    cat.conf.onCut=function(obj){
                        _mySound.playSound("hall_cat_cut");
                        claws.myObj.stop();
                        claws.myObj.fadeOut(120);
                        claws.myObj.stopSound();
//                        claws.step_max=120;
                        var pos_start=obj.cut_data.pos;
                        pos_start[0]-=20*scale/100;
                        
                        
                        this.addViewObj(myPixiObj.drawCustom,[{
                            spine_conf:{
                                anim_loop:true,
                                spineResource:gameObj.takeSpineResources()
                            },
                            anim_type:"spine",
                            img:"cat_spirit",
                            scale_arr:[obj.cut_data.scale,obj.cut_data.scale],
                            step_max:0,
                            dir:obj.cut_data.dir,
                            v:3,
                            pos_start:obj.cut_data.pos,pos_end:[obj.cut_data.pos[0],-200]
                        }]);
                        
                        gameObj.addViewObj(myPixiObj.drawCustom,[{
                            img:"cat_down_die",
                            anim_type:"spine",
                            pos_start:pos_start,
                            pos_end:[pos_start[0],1000],
                            step_max:0,
                            v:5,
                            a:0.05,
                            scale_arr:[scale*0.85,scale*0.85],
                            spine_conf:{spineResource:gameObj.takeSpineResources()}
                        }]);
                    
                    
                    
                        

                    };
                    cat.conf.onEnd=function(){
                        claws.myObj.stop();
                        claws.myObj.fadeOut(120);
                        claws.myObj.stopSound();
//                        claws.step_max=120;
                    };
                    
                }
            }));
            
            
            
            
            
        }
        
        
        
        for(i=0;i<chick;i++){
            addCat();
        }
        function addBat(){
            gameObj.addMovePath("bat1",{
                spine_conf:{
                    spineResource:gameObj.takeSpineResources(),
                    anim_name:"fly",
                    anim_loop:true
                },
                anim_type:"spine",
                img:"bat",
                map_name:"halloween_bat_fly",
                change_dir:-1,
                scale_sm:[100,80,60,50,45,40,35,15],
                point_center:[mt_rand(100,1180),mt_rand(50,500)],
                onCut:function(obj){
                    _mySound.playSound("hall_bat_cut");
                    var data=obj.cut_data;
                    var scale_step=data.scale-15;
                    gameObj.addMovePath("bat2",{
                        spine_conf:{
                            spineResource:gameObj.takeSpineResources(),
                            anim_name:"aggressive",
                            anim_loop:true
                        },
                        anim_type:"spine",
                        img:"bat",
                        map_name:"halloween_bat_aggressive",
                        change_dir:-1,
                        speed:0.7,
                        point_center:[mt_rand(100,1180),mt_rand(50,500)],
                        scale_sm:[data.scale,0.8*scale_step+15,0.6*scale_step+15,0.5*scale_step+15,0.45*scale_step+15,0.4*scale_step+15,15],
                        point_start:data.pos,
                        cut_from_step:20,
                        onCut:function(obj){
                             _mySound.playSound("chick_die");
                            var data=obj.cut_data;
                            gameObj.addViewObj(myPixiObj.drawCustom,[{
                                img:"bat",
                                anim_type:"spine",
                                pos_start:data.pos,
                                pos_end:[data.pos[0],1000],
                                step_max:0,
                                dir:data.dir,
                                v:5,
                                a:0.05,
                                scale_arr:[data.scale,data.scale],
                                spine_conf:{
                                    spineResource:gameObj.takeSpineResources(),
                                    anim_name:"die",
                                    anim_loop:true
                                }
                            }]);

                        }
                    });
                }
            });
        }
        for(i=0;i<bat;i++){
            addBat();
        }
        
        
        
    },
    
    startBoss:function(){
        
        var uiJS=$(".place.hallninja #hallGameUI");
        uiJS.find("#eggBox").hide();
        uiJS.find("#witchBox").show();
        this.updateWitch();
        
        var gameObj=this.game_obj;
        var game_state=this.state;
        var indexWitch=_moduleTimeHandler.getNewIndex();
        function addWitch(){
            if(game_state.boss.val>=game_state.boss.val_need){
                return false;
            }
            _moduleTimeHandler.setOne(indexWitch,function(){
                _mySound.playSound("hall_witch_start");
            },300);
            var scale_range=[40,70];
            var scale=scale_range[1]-(scale_range[1]-scale_range[0])*game_state.boss.val/(game_state.boss.val_need-1);//40,70
            var range=[
                [-400,1680],
                [100,580]
            ];
            
            var pos_start=[-400,mt_rand(range[1][0],range[1][1])],
            pos_end=[1680,mt_rand(range[1][0],range[1][1])],
            dir=-1;
            
            var need_points=7,distance_x=pos_end[0]-pos_start[0];
            
            function findPoint(last_point){
                var qdir=1;
                if(mt_rand(0,100)<50){
                    qdir=-1;
                }
                if(last_point[1]==range[1][1]){
                    qdir=-1;
                }
                if(last_point[1]==range[1][0]){
                    qdir=1;
                }
                var next_point=[
                    last_point[0]+mt_rand(70,130)/100*distance_x/need_points,
                    last_point[1]
                ];
                next_point[1]+=mt_rand(100,300)*qdir;
                next_point[1]=Math.max(range[1][0],next_point[1]);
                next_point[1]=Math.min(range[1][1],next_point[1]);
                return next_point;
            }
            var i,sm_points=[],last_point=copyArray(pos_start);
            sm_points.push(pos_start);
            for(i=0;i<need_points;i++){
                last_point=findPoint(last_point);
                sm_points.push(copyArray(last_point));
            }
            
            if(mt_rand(0,100)<50){
                dir=1;
                sm_points.reverse();
            }
            
            gameObj.addCollisionCustom("witch",{
                anim_type:"spine",
                img:"witch",
                scale_arr:[scale,scale*0.75],
                step_max:0,
                v:8,
                sm_points_arr:sm_points,
                dir:dir,
                map_name:"hallninja_witch",
                spine_conf:{
                    anim_loop:true,
                    spineResource:gameObj.takeSpineResources()
                },
                onEnd:function(){
                    addWitch();
                },
                onCut:function(obj){
                    _mySound.playSound("hall_witch_cut");
                    
                    var data=obj.cut_data;
//                    if(game_state.boss.val>=game_state.boss.val_need){
//                        return false;
//                    }
                    gameObj.addViewObj(myPixiObj.drawCustom,[{
                        anim_type:"spine",
                        img:"witch_die1",
                        scale_arr:[data.scale,data.scale],
                        step_max:0,
                        v:5,
                        dir:data.dir,
                        pos_start:data.pos,pos_end:[data.pos[0],1100],
                        spine_conf:{
                            anim_loop:false,
                            spineResource:gameObj.takeSpineResources()
                        },
                        onEndAnim:function(){
                            addWitch();
                        }
                    }]);
                    
                    return false;
                    
                    var data=obj.cut_data;
                    var pos_end=[range[0][0],mt_rand(range[1][0],range[1][1])];
                    if(data.dir==-1){
                        pos_end[0]=range[0][1];
                    }
                    gameObj.addCollisionCustom("witch",{
                        img:"witch",
                        anim_type:"spine",
                        pos_start:data.pos,
                        pos_end:pos_end,
                        step_max:0,
                        dir:data.dir,
                        v:30,
                        cut_from_step:20,
                        scale_arr:[data.scale,data.scale],
                        map_name:"hallninja_witch",
                        spine_conf:{
                            spineResource:gameObj.takeSpineResources(),
                            anim_loop:true
                        },
                        onCut:function(){
                            addWitch();
                        },
                        onEnd:function(){
                            addWitch();
                        }
                    });
                    
                    
                }
            });
        }
        addWitch();
        
        
    },
    updateWitch:function(){
        var uiJS=$(".place.hallninja #hallGameUI #witchBox");
        var wrapHead=uiJS.find('#headWrapJS'),html="";
        var i=0,i_max=this.state.boss.val_need;
        for(i=0;i<i_max;i++){
            if(i_max-i>this.state.boss.val){
                html+="<div class='head'><div class='in'></div></div>";
            }
            else{
                html+="<div class='head cut'><div class='in'></div></div>";
            }
        }
        wrapHead.html(html);
    },
    gameHandler:function(){
        var thc=this;
        var gameObj=this.game_obj;
        
        var uiJS=$(".place.hallninja #hallGameUI");

        
        function updateScore(){
            var eggUI=uiJS.find("#eggBox");
            eggUI.find(".valJS[data-type='egg']").html(thc.state.val);
            var percent=thc.state.val/thc.state.val_need*100;
            percent=Math.min(100,percent);
            eggUI.find(".beltWrap>.fill").height(percent+"%");
        }
        function getLive(howmany,reason_id){
            if(thc.state.lives==1){
                thc.witchObj.use();
            }
            if(!thc.witchObj.isActive()){
                thc.state.lives-=howmany;
                if(thc.state.lives<=0 && thc.stage.res==""){
                    gameObj.stopCut();
                    thc.stage.res="lose";
                    thc.conf.onLose({val:thc.state.val,reason_id:reason_id});
                }
                thc.state.lives=Math.max(thc.state.lives,0);
            }
            
            
            var wrapHead=uiJS.find('#heartWrapJS'),html="";
            var i=0,i_max=thc.state.lives_max;
            for(i=1;i<i_max+1;i++){
                if(intval(thc.state.lives)>=i){
                    html+="<div class='heart'><div class='in'></div></div>";
                }
                else{
                    html+="<div class='heart'></div>";
                }
            }
            wrapHead.html(html);
            
        }
        updateScore();
        getLive(0);
        
        _moduleEvents.on("cutGameEvent",function(obj){
            var log_arr=gameObj.getLogs();
            var i,bum,change_live=0,change_score=0;
            for(i in log_arr){
                bum=log_arr[i];
                var cut_data=bum.cut_data;
                if(bum.type=="cut"){
                    if(cut_data.type=="egg"){
                        //score
                        thc.state.val+=1;
                        change_score++;
                    }
                    if(cut_data.type=="bat1"){
                        thc.state.val+=1;
                        change_score++;
                    }
                    if(cut_data.type=="bat2"){
                        //score
                        thc.state.val+=4;
                        change_score++;
                    }
                    if(cut_data.type=="chick"){
                        getLive(1,1);
                    }
                    if(cut_data.type=="witch"){
                        thc.state.boss.val++;
                        thc.updateWitch();
                        if(thc.state.boss.val>=thc.state.boss.val_need && thc.stage.res==""){
                            thc.stage.res="win";
                            var killObj= gameObj.addFrontObj(myPixiObj.drawCustom,[{
                                 spine_conf:{
                                     spineResource:gameObj.takeSpineResources(),
                                     onAnimComplete:function(){
                                         killObj.step_max=1;
                                         thc.conf.onWin({val:thc.state.val,boss:1,wait:0});
                                     }
                                 },
                                 anim_type:"spine",
                                 img:"witch_big",
                                 step_max:0,
                                 pos_start:[0,0],pos_end:[0,0]
                             }]);
                        }
                    }
                }
                if(bum.type=="end"){
                    if(cut_data.type=="egg"){
                        //lose
                        getLive(1,2);
                    }
                }
            }
            if(change_score){
                updateScore();
            }
        });
        
        
        
        
    }
});